import type { SharedEmailProvider } from '@core/email-providers-types';
import { createEntityCollectionStore } from '@core/ngrx-legacy';

import { EntityStoreKey } from '../types';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<SharedEmailProvider>()(EntityStoreKey.mailboxSharedEmailProviders);

const MailboxSharedEmailProvidersActions: Pick<
  typeof actions,
  'fetchCollection' | 'fetchCollectionSuccess' | 'fetchCollectionFailed'
> = actions;

export {
  MailboxSharedEmailProvidersActions,
  selectors as MailboxSharedEmailProvidersSelectors,
  reducer as MailboxSharedEmailProvidersReducer,
  namespace as MailboxSharedEmailProvidersNamespace,
};
